import { Component } from '@angular/core';
import { HomesFacade } from '@library/store/homes/homes.facade';
import { EnumMeasureTypes } from '@library/store/measures/measures.interface';
import { ModulesFacade } from '@library/store/modules/modules.facade';
import { isDefined } from '@library/utils/helpers/store/is-defined';
import { SideBarCardExpandAnimation } from '@pages/control-page/control-page-main/control-page-dashboard/control-page-sidebar/components/sidebar-card/sidebar-card.component';
import { ControlPageCardService } from '@pages/control-page/control-page-main/control-page-dashboard/control-page-sidebar/control-page-card.service';
import { ConsumptionUnit, ControlPageStore, DatasetCard, GraphType } from '@pages/control-page/control-page-store.service';
import { Enums } from 'constants/Enums.constant';
import { combineLatest, map } from 'rxjs';
import { SidebarCardExpandComponent } from '../../components/sidebar-card/sidebar-card-expand/sidebar-card-expand.component';

@Component({
  selector: 'app-home-consumption-card',
  templateUrl: './home-consumption-card.component.html',
  styleUrls: ['./home-consumption-card.component.scss'],
  animations: [SideBarCardExpandAnimation],
})
export class HomeConsumptionCardComponent {

  tabs: {[key in GraphType]?: {value: ConsumptionUnit, measureType: EnumMeasureTypes}[]} = {
    [GraphType.ELEC]: [
      {value: ConsumptionUnit.PRICE, measureType: EnumMeasureTypes.SUM_ENERGY_PRICE_BASE},
      {value: ConsumptionUnit.CONSUMPTION, measureType: EnumMeasureTypes.SUM_ENERGY_ELEC_BASE},
    ],
    [GraphType.ELEC_PEAK_OFFPEAK]: [
      {value: ConsumptionUnit.PRICE, measureType: EnumMeasureTypes.SUM_ENERGY_PRICE_BASE},
      {value: ConsumptionUnit.CONSUMPTION, measureType: EnumMeasureTypes.SUM_ENERGY_ELEC_BASE},
    ],
    [GraphType.WATER]: [
      {value: ConsumptionUnit.PRICE, measureType: EnumMeasureTypes.SUM_FLUID_PRICE_HOT_WATER},
      {value: ConsumptionUnit.CONSUMPTION, measureType: EnumMeasureTypes.SUM_FLUID_CONSUMPTION_HOT_WATER},
    ],
    [GraphType.GAS]: [
      {value: ConsumptionUnit.PRICE, measureType: EnumMeasureTypes.SUM_FLUID_PRICE_GAS},
      {value: ConsumptionUnit.CONSUMPTION, measureType: EnumMeasureTypes.SUM_FLUID_CONSUMPTION_GAS},
    ],
  };

  unit$ = this.controlPageStore.homeConsumptionUnit$;

  vm$ = combineLatest({
    card: this.controlPageStore.card$,
    home: this.homesFacade.currentHome$,
    unit: this.unit$,
    selectedTabIndex: combineLatest({
      unit: this.unit$,
      card: this.controlPageStore.card$.pipe(isDefined())
    }).pipe(
      map(({unit, card: {graphType}}) =>  this.tabs[graphType]?.findIndex(t => t.value === unit) ?? this.tabs[GraphType.ELEC].findIndex(t => t.value === unit))
    ),
  });

  hasNLE$ = this.modulesFacade.currentHomeModules$.pipe(
    map(modules => modules.some(m => m.type == Enums.ModuleType.NLE)),
  );

  GraphType = GraphType;

  constructor(
    private modulesFacade: ModulesFacade,
    private controlPageStore: ControlPageStore,
    private homesFacade: HomesFacade,
    private controlPageCardService: ControlPageCardService,
  ) { }

  hasElec = (card: DatasetCard) => card.graphType === GraphType.ELEC || card.graphType === GraphType.ELEC_PEAK_OFFPEAK;
  hasWater = (card: DatasetCard) => card.graphType === GraphType.WATER;
  hasGas = (card: DatasetCard) => card.graphType === GraphType.GAS;

  selectUnit(event: Event, unit: ConsumptionUnit, graphType: GraphType) {
    // Stop propagation to avoid the card to be expanded
    event.stopPropagation();

    this.controlPageStore.selectHomeConsumptionUnit(unit);
    switch (graphType) {
      case GraphType.GAS:
        this.controlPageCardService.selectHomeGas(unit);
        break;
      case GraphType.WATER:
        this.controlPageCardService.selectHomeWater(unit);
        break;
      case GraphType.ELEC:
      case GraphType.ELEC_PEAK_OFFPEAK:
      default:
        this.controlPageCardService.selectHomeElec(unit);
        break;
    }
  }

  // This is used to open the sidebar card when the user clicks on all the card (not only the expand button)
  toggle(sidebarCardExpand: SidebarCardExpandComponent) {
    sidebarCardExpand.toggle();
  }

}
